const Palettes = {
  PAL_ALTI: [
    [0, 0, 0, 255, 255],
    [250, 0, 85, 255, 255],
    [500, 0, 170, 255, 255],
    [750, 0, 255, 255, 255],
    [1000, 3, 230, 175, 255],
    [1250, 5, 204, 95, 255],
    [1500, 8, 179, 15, 255],
    [1750, 88, 204, 10, 255],
    [2000, 168, 228, 5, 255],
    [2250, 248, 253, 0, 255],
    [2500, 255, 228, 0, 255],
    [2750, 255, 198, 0, 255],
    [3000, 255, 168, 0, 255],
    [3250, 255, 115, 0, 255],
    [3500, 255, 60, 0, 255],
    [3750, 255, 5, 0, 255],
    [4000, 204, 0, 41, 255],
    [4250, 148, 0, 87, 255]
  ],
  PAL_THERMIQUES: [
    [0, 255, 255, 255, 255],
    [0.5, 255, 247, 172, 255],
    [1, 255, 231, 0, 255],
    [1.5, 202, 222, 45, 255],
    [2, 101, 214, 0, 255],
    [2.5, 0, 255, 181, 255],
    [3, 0, 208, 255, 255],
    [3.5, 0, 128, 255, 255],
    [4, 0, 0, 255, 255],
    [4.5, 128, 0, 255, 255],
    [5, 255, 0, 255, 255],
    [5.5, 255, 0, 128, 255],
    [6, 255, 0, 0, 255],
    [6.5, 128, 0, 0, 255],
    [7, 0, 0, 0, 255]
  ],
  PAL_BSRATIO: [
    [0, 165, 0, 38, 255],
    [1, 215, 48, 39, 255],
    [2, 244, 109, 67, 255],
    [3, 253, 174, 97, 255],
    [4, 254, 224, 139, 255],
    [5, 217, 239, 139, 255],
    [6, 166, 217, 106, 255],
    [7, 102, 189, 99, 255],
    [8, 26, 152, 80, 255],
    [9, 0, 104, 55, 255]
  ],
  PAL_WIND: [
    [0, 255, 255, 255, 255],
    [0.92, 0, 255, 255, 255],
    [1.86, 3, 230, 175, 255],
    [2.78, 5, 204, 95, 255],
    [3.69, 8, 179, 15, 255],
    [4.64, 88, 204, 10, 255],
    [5.56, 168, 228, 5, 255],
    [6.47, 248, 253, 0, 255],
    [7.42, 255, 228, 0, 255],
    [8.33, 255, 198, 0, 255],
    [9.25, 255, 168, 0, 255],
    [10.19, 255, 115, 0, 255],
    [11.11, 255, 60, 0, 255],
    [12.03, 255, 5, 0, 255],
    [12.97, 204, 0, 41, 255],
    [13.89, 148, 0, 87, 255]
  ],
  PAL_CAPE: [
    [0, 255, 255, 255, 255],
    [500, 255, 255, 172, 255],
    [1000, 255, 255, 0, 255],
    [1500, 255, 206, 0, 255],
    [2000, 255, 100, 0, 255],
    [2500, 255, 0, 0, 255],
    [3000, 255, 0, 255, 255],
    [3500, 128, 0, 128, 255],
    [4000, 0, 0, 255, 255],
    [4500, 0, 0, 128, 255],
    [5000, 0, 0, 0, 255]
  ],
  PAL_CFRAC: [
    /* [0, 82, 81, 115, 255],
    [10, 99, 98, 129, 255],
    [20, 116, 115, 143, 255],
    [30, 113, 113, 157, 255],
    [40, 151, 150, 171, 255],
    [50, 168, 168, 185, 255],
    [60, 185, 185, 199, 255],
    [70, 203, 203, 213, 255],
    [80, 220, 220, 227, 255],
    [90, 237, 237, 241, 255],
    [100, 255, 255, 255, 255] */
    [0, 204, 204, 204, 255],
    [10, 189, 198, 209, 255],
    [20, 172, 189, 214, 255],
    [30, 156, 181, 219, 255],
    [40, 136, 172, 224, 255],
    [50, 116, 161, 229, 255],
    [60, 97, 152, 235, 255],
    [70, 72, 139, 240, 255],
    [80, 51, 129, 245, 255],
    [90, 26, 116, 250, 255],
    [100, 0, 102, 255, 255]
  ],
  PAL_TEMP: [
    [0, 0, 0, 255, 255],
    [2.5, 0, 85, 255, 255],
    [5, 0, 170, 255, 255],
    [7.5, 0, 255, 255, 255],
    [10, 3, 230, 175, 255],
    [12.5, 5, 204, 95, 255],
    [15, 8, 179, 15, 255],
    [17.5, 88, 204, 10, 255],
    [20, 168, 228, 5, 255],
    [22.5, 248, 253, 0, 255],
    [25, 255, 228, 0, 255],
    [27.5, 255, 198, 0, 255],
    [30, 255, 168, 0, 255],
    [32.5, 255, 115, 0, 255],
    [35, 255, 60, 0, 255],
    [37.5, 255, 5, 0, 255],
    [40, 204, 0, 41, 255]
  ],
  PAL_CONVERGENCE: [
    [-2.5, 165, 0, 38, 255],
    [-2, 215, 48, 39, 255],
    [-1.5, 244, 109, 67, 255],
    [-1, 253, 174, 97, 255],
    [-0.5, 254, 224, 139, 255],
    [0, 217, 239, 139, 255],
    [0.5, 166, 217, 106, 255],
    [1, 102, 189, 99, 255],
    [1.5, 26, 152, 80, 255],
    [2, 0, 104, 55, 255]
  ],
  PAL_CBASE: [
    [-1, 220, 220, 220, 255],
    [0.1, 0, 0, 255, 255],
    [250, 0, 85, 255, 255],
    [500, 0, 170, 255, 255],
    [750, 0, 255, 255, 255],
    [1000, 3, 230, 175, 255],
    [1250, 5, 204, 95, 255],
    [1500, 8, 179, 15, 255],
    [1750, 88, 204, 10, 255],
    [2000, 168, 228, 5, 255],
    [2250, 248, 253, 0, 255],
    [2500, 255, 228, 0, 255],
    [2750, 255, 198, 0, 255],
    [3000, 255, 168, 0, 255],
    [3250, 255, 115, 0, 255],
    [3500, 255, 60, 0, 255],
    [3750, 255, 5, 0, 255],
    [4000, 204, 0, 41, 255],
    [4250, 148, 0, 87, 255]
  ],
  PAL_RAIN: [
    [0, 204, 204, 204, 255],
    [0.1, 170, 255, 255, 255],
    [1, 85, 213, 255, 255],
    [2, 42, 170, 255, 255],
    [5, 42, 127, 255, 255],
    [10, 0, 85, 192, 255],
    [15, 0, 42, 192, 255],
    [20, 170, 0, 127, 255]
  ],
  PAL_ALTI_CB: [
    [-250, 255, 255, 255, 255],
    [0.1, 255, 255, 217, 255],
    [500, 237, 248, 217, 255],
    [1000, 199, 233, 180, 255],
    [1500, 127, 205, 187, 255],
    [2000, 65, 182, 196, 255],
    [2500, 29, 145, 192, 255],
    [3000, 34, 94, 168, 255],
    [3500, 37, 52, 148, 255],
    [4000, 8, 29, 88, 255],
    [4500, 0, 0, 0, 255]
  ],
  PAL_THERMIQUES_CB: [
    [0, 255, 255, 255, 255],
    [0.5, 255, 255, 204, 255],
    [1, 255, 237, 160, 255],
    [1.5, 254, 217, 118, 255],
    [2, 254, 178, 76, 255],
    [2.5, 253, 141, 60, 255],
    [3, 252, 78, 42, 255],
    [3.5, 227, 26, 28, 255],
    [4, 177, 0, 38, 255],
    [4.5, 0, 0, 0, 255]
  ],
  PAL_BSRATIO_CB: [
    [0, 142, 1, 82, 255],
    [1, 197, 27, 125, 255],
    [2, 222, 119, 174, 255],
    [3, 241, 182, 218, 255],
    [4, 253, 224, 239, 255],
    [5, 230, 245, 208, 255],
    [6, 184, 225, 134, 255],
    [7, 127, 188, 65, 255],
    [8, 77, 146, 33, 255],
    [9, 39, 100, 25, 255]
  ],
  PAL_WIND_CB: [
    [0, 255, 255, 255, 255],
    [1.39, 255, 255, 217, 255],
    [2.78, 237, 248, 177, 255],
    [4.17, 199, 233, 180, 255],
    [5.56, 127, 205, 187, 255],
    [6.94, 65, 182, 196, 255],
    [8.33, 29, 145, 192, 255],
    [9.72, 34, 94, 168, 255],
    [11.1, 12, 44, 132, 255],
    [12.5, 0, 0, 0, 255]
  ],
  PAL_PRESS: [
    [995, 0, 0, 255, 255],
    [997, 0, 85, 255, 255],
    [999, 0, 170, 255, 255],
    [1001, 0, 255, 255, 255],
    [1003, 3, 230, 175, 255],
    [1005, 5, 204, 95, 255],
    [1007, 8, 179, 15, 255],
    [1009, 88, 204, 10, 255],
    [1011, 168, 228, 5, 255],
    [1013, 248, 253, 0, 255],
    [1015, 255, 228, 0, 255],
    [1017, 255, 198, 0, 255],
    [1019, 255, 168, 0, 255],
    [1021, 255, 115, 0, 255],
    [1023, 255, 60, 0, 255],
    [1025, 255, 5, 0, 255],
    [1027, 204, 0, 41, 255],
    [1029, 148, 0, 87, 255]
  ]
}

export function whichPalette(p) {
  p = p.toUpperCase()
  let c
  if (p === 'TER') {
    c = 'PAL_ALTI'
  } else if (p === 'WSTAR') {
    c = 'PAL_THERMIQUES'
  } else if (p === 'BSRATIO') {
    c = 'PAL_BSRATIO'
  } else if (p === 'PBLTOP') {
    c = 'PAL_ALTI'
  } else if (p === 'HCRIT') {
    c = 'PAL_ALTI'
  } else if (p === 'WINDBLAVG') {
    c = 'PAL_WIND'
  } else if (p === 'WINDBLTOP') {
    c = 'PAL_WIND'
  } else if (p === 'WINDSFC') {
    c = 'PAL_WIND'
  } else if (p === 'WIND1000') {
    c = 'PAL_WIND'
  } else if (p === 'WIND2000') {
    c = 'PAL_WIND'
  } else if (p === 'WIND3000') {
    c = 'PAL_WIND'
  } else if (p === 'WIND4000') {
    c = 'PAL_WIND'
  } else if (p === 'BLWINDSHEAR') {
    c = 'PAL_WIND'
  } else if (p === 'CAPE2D') {
    c = 'PAL_CAPE'
  } else if (p === 'CFRACL') {
    c = 'PAL_CFRAC'
  } else if (p === 'CFRACM') {
    c = 'PAL_CFRAC'
  } else if (p === 'CFRACH') {
    c = 'PAL_CFRAC'
  } else if (p === 'CFRACTOT') {
    c = 'PAL_CFRAC'
  } else if (p === 'CFRACALTI') {
    c = 'PAL_CFRAC'
  } else if (p === 'BLCLOUDPCT') {
    c = 'PAL_CFRAC'
  } else if (p === 'PBLH') {
    c = 'PAL_ALTI'
  } else if (p === 'TC2') {
    c = 'PAL_TEMP'
  } else if (p === 'TD2') {
    c = 'PAL_TEMP'
  } else if (p === 'TEMPALTI') {
    c = 'PAL_TEMP'
  } else if (p === 'WBLMAXMIN') {
    c = 'PAL_CONVERGENCE'
  } else if (p === 'WSFC10') {
    c = 'PAL_CONVERGENCE'
  } else if (p === 'WSFC30') {
    c = 'PAL_CONVERGENCE'
  } else if (p === 'ZSFCLCLMASK') {
    c = 'PAL_CBASE'
  } else if (p === 'ZBLCLMASK') {
    c = 'PAL_CBASE'
  } else if (p === 'RAINTOT') {
    c = 'PAL_RAIN'
  } else if (p === 'SLP') {
    c = 'PAL_PRESS'
  }
  return c
}

export function getPalette(name) {
  return Palettes[name]
}

export function getColor(val, pal) {
  let i

  const max = Palettes[pal].length - 1

  for (i = 0; i < max; i++) {
    if (val < Palettes[pal][i + 1][0]) break
  }

// if (val-pal[cx][i-1][0] < pal[cx][i][0]-val) i--;

  return {
    r: Palettes[pal][i][1],
    g: Palettes[pal][i][2],
    b: Palettes[pal][i][3],
    a: Palettes[pal][i][4] / 255
  }
}



// WEBPACK FOOTER //
// ./src/assets/palette.js